import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { router } from "@/app/router";
import { AuthProvider } from "@/features/auth/AuthProvider";
import { assertMockGuard } from "@/mocks/guard";
import { LoadingBlock } from "@/components/ui/states";
import "./styles.css";

assertMockGuard();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Suspense
          fallback={
            <div className="min-h-screen bg-off-white px-4 py-24">
              <div className="mx-auto max-w-6xl">
                <LoadingBlock label="Loading Soweto Super United FC" />
              </div>
            </div>
          }
        >
          <RouterProvider router={router} />
        </Suspense>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
